import FluxUtils from 'flux/utils';
import Immutable from 'immutable';

import type { ActionType } from 'sharedreact/actions/generic/actions';
import AuthenticationConstants from 'sharedreact/constants/AuthenticationConstants';
import UserPreferencesConstants from 'sharedreact/constants/UserPreferencesConstants';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';

const Content: {
  preferences: Immutable.Map<string, any>,
} = {
  preferences: Immutable.Map()
};

class State extends Immutable.Record(Content) {
  setPreference (key: string, value: any): State {
    return this.set('preferences', this.preferences.set(key, value));
  }
}

class UserPreferencesStore extends FluxUtils.ReduceStore<State, ActionType> {
  constructor () {
    super(AppDispatcher);
  }

  override getInitialState (): State {
    return new State();
  }

  override reduce (state: State, action: ActionType): State {
    let retval = state;

    switch (action.actionType) {
      case AuthenticationConstants.LOGOUT_SUCCESS: {
        // clear the preferences
        retval = this.getInitialState();
        break;
      }
      case UserPreferencesConstants.SET_PREFERENCE: {
        retval = retval.setPreference(action.name, action.value);
        break;
      }
      case UserPreferencesConstants.GET_SUCCESS: {
        if (action.preferences != null) {
          let newPreferences = Immutable.fromJS(action.preferences);
          retval = new State(newPreferences);
        } else {
          retval = this.getInitialState();
        }
        break;
      }
      case UserPreferencesConstants.CLEAR_SUCCESS: {
        return this.getInitialState();
      }
    }

    return retval;
  }

  getPreference (name: string): any {
    return this.getState().preferences.get(name);
  }
}

export default new UserPreferencesStore();
